import { render, staticRenderFns } from "./RiskRow.vue?vue&type=template&id=bf9ecade&scoped=true&"
import script from "./RiskRow.vue?vue&type=script&lang=js&"
export * from "./RiskRow.vue?vue&type=script&lang=js&"
import style0 from "./RiskRow.vue?vue&type=style&index=0&id=bf9ecade&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9ecade",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VEditDialog } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VEditDialog,VIcon,VSelect,VTextField})
